import {Component, forwardRef, Input, OnChanges, SimpleChanges} from '@angular/core';
import {ControlValueAccessor, UntypedFormControl, NG_VALUE_ACCESSOR} from '@angular/forms';
import {errorMessages} from '../../core/errors/error-messages';
import * as _ from 'lodash';
import { NgIf } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { ColorPickerModule } from 'ngx-color-picker';

@Component({
    selector: 'app-color-input',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ColorInputComponent),
            multi: true
        }
    ],
    template: `
    <div class="form-group" [class.has-error]="showErrors()">
      <label [for]="_id" [class.sr-only]="inlineLabel" *ngIf="!hideLabel">
        <span class="label-text">{{label}}</span>
        <mat-icon class="explanation" *ngIf="!!explanation" matTooltip="{{explanation}}">info_outline</mat-icon>
      </label>
      <input [type]="type" class="form-control" [id]="_id" [name]="name" (touched)="onTouched()" [value]="value"
             [placeholder]="placeholder ? placeholder : inlineLabel ? label : ''"
             [disabled]="disabled"
             [(colorPicker)]="value" [style.background]="value"
             (colorPickerClose)="onPickerChange($event)"
             (input)="onChange($event.target['value'])">
      <span class="help-block" *ngIf="showErrors()">{{firstError()}}</span>
      <span class="help-block info-block" *ngIf="!showErrors()">{{infoText}}</span>
    </div>`,
    styles: [
        '.label-text {vertical-align: middle;}'
    ],
    standalone: true,
    imports: [NgIf, MatIcon, MatTooltip, ColorPickerModule]
})
export class ColorInputComponent implements ControlValueAccessor, OnChanges {

  @Input() formControl: UntypedFormControl;
  @Input() label: string;
  @Input() infoText: string;
  @Input() name: string;
  @Input() id: string;
  @Input() submitted: boolean;
  @Input() inlineLabel = false;
  @Input() placeholder: string;
  @Input() type: string;
  @Input() formValidators: any[];
  @Input() explanation: string;
  @Input() disabled: boolean;
  @Input() hideLabel = false;


  value: any;
  isDisabled: boolean;
  firstFormError: any;
  _id: string;

  constructor() {
    this.setId();
  }

  propagateChange = (e: any) => {
  };

  onTouched = (e?: any) => {
  };

  ngOnChanges(changes: SimpleChanges): void {

  }

  setId(): void {
    if (this.id) {
      this._id = this.id;
    }
    if (this.name) {
      this._id = this._id = _.uniqueId(`${this.name}_`);
    }

    this._id = _.uniqueId('id_');
  }

  showErrors() {
    return (!this.isValid() && this.isDirty()) || (this.submitted && !this.isValid() || this.hasFormError());
  }

  isUnTouched() {
    if (this.formControl && this.formControl.untouched) {
      return true;
    }
    return false;
  }

  isValid() {
    if (this.formControl && this.formControl.valid) {
      return true;
    }
    return false;
  }

  isDirty() {
    if (this.formControl && this.formControl.dirty) {
      return true;
    }
    return false;
  }

  hasFormError() {
    if (!this.formControl) {
      return false;
    }

    const formErrors = this.formControl.parent.errors;

    if (this.formValidators) {

      for (const error in formErrors) {
        if (formErrors.hasOwnProperty(error)) {
          this.firstFormError = this.formValidators.find((item) => {
            return item.key === error;
          });

          if (this.firstFormError) {
            return true;
          }
        }
      }
    }
    return false;
  }

  firstError(): string {

    if (this.hasFormError()) {
      return this.firstFormError.error;
    }

    if (this.formControl && this.formControl.errors) {
      for (const error in this.formControl.errors) {
        if (this.formControl.errors.hasOwnProperty(error)) {

          // get error description
          let message = errorMessages[error];
          if (!message) {
            message = `Unknown error: ${error}`;
          }
          return message;
        }
      }
    }

    return null;
  }

  errors(): string[] {
    const errorsMessages = [];
    if (this.formControl && this.formControl.errors) {
      for (const error in this.formControl.errors) {
        if (this.formControl.errors.hasOwnProperty(error)) {

          // get error description
          const message = errorMessages[error];
          if (message) {
            errorsMessages.push(message);
          } else {
            errorsMessages.push(`Unknown error: ${error}`);
          }
          console.log(error);
        }
      }
    }

    return errorsMessages;
  }

  writeValue(obj: any): void {
    if (obj != null && (typeof obj === 'string' || obj instanceof String)) {
      obj = obj.toString().trim();
    }
    this.value = obj;
    console.log('writeValue: ' + obj);
  }

  onChange(event) {
    console.log(event);
    if (event != null && (typeof event === 'string' || event instanceof String)) {
      event = event.toString().trim();
    }

    this.onTouched();
    this.propagateChange(event);
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  onPickerChange($event: string) {
    console.log(event, this.value);

    this.onTouched();
    this.propagateChange(this.value);
  }
}
